<div
  class="tw-px-2 tw-pt-2"
  [class]="
    sideNavService.open()
      ? 'tw-sticky tw-top-0 tw-z-50 tw-pb-4'
      : 'tw-pb-[calc(theme(spacing.8)_+_2px)]'
  "
>
  <!-- absolutely position the link svg to avoid shifting layout when sidenav is closed -->
  <a
    [routerLink]="route()"
    class="tw-relative tw-p-3 tw-block tw-rounded-md tw-bg-bg-sidenav tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-inset focus-visible:tw-ring-border-focus hover:tw-bg-bg-sidenav-item-hover tw-h-[155.333px] [&_svg]:tw-absolute [&_svg]:tw-inset-[.6875rem] [&_svg]:tw-w-[250px]"
    [class]="!sideNavService.open() ? '!tw-h-[55px] [&_svg]:!tw-w-[26px]' : ''"
    [attr.aria-label]="label()"
    [title]="label()"
    routerLinkActive
    ariaCurrentWhenActive="page"
  >
    <bit-svg [content]="sideNavService.open() ? openIcon() : closedIcon()"></bit-svg>
  </a>
</div>
